import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { Image } from "react-bootstrap";
import { mapStateToProps, mapDispatchToProps } from "../../RootReducer";
import { loadUserRole } from "../helpers/HelperFunctions";
import { hasRole } from "../helpers/Permissions";
import Materialicon from "../helpers/Materialicon";
import API from "../../services/APIService";
import SubPages from "./SubPages";

class Aside extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			userRole: null
		};
	}
	componentWillMount() {
		const { user } = this.props.globalState.userLoginData;
		const role = loadUserRole(user.roles);
		const isTester = hasRole(5);
		this.setState({ userRole: role, isTester });
	}
	
	staticUrl = API.getStaticUrl();
	render() {
		const { first_name: firstName, last_name: lastName, image } = this.props.globalState.userLoginData.user;
		const { userRole, isTester } = this.state;
		return (
			<aside>
				<section className="sidebar">
					<div className="user-panel">
						<div className="pull-left image">
							<Image src={`${this.staticUrl}/uploads/${image || "defaultUserImage.png"}`} alt="user-avatar" />								
						</div>
						<div className="pull-left info">
							<p>{`${firstName} ${lastName}`}</p>
							<span className="text-success"><Materialicon icon="fiber_manual_record" /></span> Online
						</div>
					</div>
					<hr className="aside-divider"/>

					{/* Super-Admin */}
					{ (userRole === 1) &&
						<nav className="sidebar-nav">						
							<NavLink to="/dashboard" activeClassName="active">
								<Materialicon icon="dashboard" /> <span className="nav-name">Dashboard</span>
							</NavLink>
						
							<NavLink to="/hierarchy" activeClassName="active">
								<Materialicon icon="line_style" /> <span className="nav-name">Hierarchy</span>
							</NavLink>

							<NavLink to="/users" activeClassName="active">
								<Materialicon icon="people_outline" /> <span className="nav-name">Users</span>
							</NavLink>

							<NavLink to="/logged-hours" activeClassName="active">
								<Materialicon icon="list" /> <span className="nav-name">List of logs</span>
							</NavLink>
							
							<SubPages title="Tasks" icon="assignment" keyID={1}>
								<Link to="/tasks/all-tasks" itemID={1}><span className="nav-name">All tasks</span> </Link>
								<Link to="/tasks/create-task" itemID={2}><span className="nav-name">New task</span> </Link> 
							</SubPages>	

							<SubPages title="Projects & Packages" icon="storage" keyID={2}>
								<Link to="/projects" itemID={1}><span className="nav-name">All projects</span></Link>
								<Link to="/projects/create-project" itemID={2}><span className="nav-name">New project</span></Link>
								<Link to="/projects/info" itemID={21}><span className="nav-name">Projects details</span></Link>			
								<Link to="/packages" itemID={3}><span className="nav-name">All packages</span></Link>				
								<Link to="/packages/create-package" itemID={4}><span className="nav-name">New package</span></Link>																
							</SubPages>	

							<SubPages title="Bugs" icon="bug_report" keyID={3}>
								<Link to="/bugs" itemID={1}><span className="nav-name">All bugs</span></Link>
								<Link to="/bugs/create-bug" itemID={2}><span className="nav-name">New bug</span></Link>																
							</SubPages>					

							<SubPages title="Day Off" icon="timer_off" keyID={4}>
								<Link to="/days-off" itemID={1}><span className="nav-name">All days off</span></Link>
								<Link to="/days-off/add-day-off" itemID={2}><span className="nav-name">New day off</span></Link>
								<Link to="/days-off/calendar" itemID={3}><span className="nav-name">Calendar</span></Link>
								<Link to="/days-off/requests" itemID={4}><span className="nav-name">Requests</span></Link>																
							</SubPages>

							<SubPages title="Miscellaneous" icon="folder" keyID={5}>
								<Link to="/skills" itemID={1}><span className="nav-name">Skills</span></Link>	
								<Link to="/areas" itemID={2}><span className="nav-name">Areas</span></Link>	
								<Link to="/performances" itemID={3}><span className="nav-name">Performances</span></Link>																
								<Link to="/payment-conditions" itemID={4}><span className="nav-name">Payment conditions</span></Link>																
								<Link to="/fixed-costs" itemID={5}><span className="nav-name">Fixed costs</span></Link>		
								<Link to="/documents" itemID={6}><span className="nav-name">Documents</span></Link>			
								<Link to="/system-logs" itemID={7}><span className="nav-name">System logs</span></Link>			
								<Link to="/system-settings" itemID={8}><span className="nav-name">System settings</span></Link>																						
							</SubPages>
						</nav>
					}
					
					{/* Admin */}
					{ (userRole === 2) &&
						<nav className="sidebar-nav">
							<NavLink to="/dashboard" activeClassName="active">
								<Materialicon icon="dashboard" /> <span className="nav-name">Dashboard</span>
							</NavLink>
							
							<NavLink to="/hierarchy" activeClassName="active">
								<Materialicon icon="line_style" /> <span className="nav-name">Hierarchy</span>
							</NavLink>

							<NavLink to="/users" activeClassName="active">
								<Materialicon icon="people_outline" /> <span className="nav-name">Users</span>
							</NavLink>
							
							<NavLink to="/documents" activeClassName="active">
								<Materialicon icon="description" /> <span className="nav-name">Documents</span>
							</NavLink>
												
							<NavLink to="/tasks/log-hours" activeClassName="active">
								<Materialicon icon="note_add" /> <span className="nav-name">Log hours</span>
							</NavLink>						

							<SubPages title="Tasks" icon="assignment" keyID={1}>
								<Link to="/tasks/all-tasks" itemID={1}><span className="nav-name">All tasks</span> </Link>
								<Link to="/tasks/create-task" itemID={3}><span className="nav-name">New task</span> </Link>	
								<Link to="/tasks/my-tasks" itemID={2}> <span className="nav-name">My tasks</span> </Link>		
								<Link to="/my-logs" itemID={4}><span className="nav-name">My logs</span> </Link>
								<Link to="/logged-hours" itemID={5}><span className="nav-name">List of logs</span> </Link>
							</SubPages>	
											
							<SubPages title="Projects & Packages" icon="storage" keyID={2}>
								<Link to="/projects" itemID={1}><span className="nav-name">All projects</span></Link>
								<Link to="/projects/create-project" itemID={2}><span className="nav-name">New project</span></Link>			
								<Link to="/packages" itemID={3}><span className="nav-name">All packages</span></Link>				
								<Link to="/packages/create-package" itemID={4}><span className="nav-name">New package</span></Link>																
							</SubPages>

							<SubPages title="Bugs" icon="bug_report" keyID={3}>
								<Link to="/bugs" itemID={1}><span className="nav-name">All bugs</span></Link>
								<Link to="/bugs/create-bug" itemID={2}><span className="nav-name">New bug</span></Link>																
							</SubPages>
							
							<SubPages title="Day Off" icon="timer_off" keyID={4}>
								<Link to="/days-off/calendar" itemID={2}><span className="nav-name">Calendar</span></Link>
								<Link to="/days-off/requests" itemID={3}><span className="nav-name">Requests</span></Link>																
							</SubPages>
						</nav>
					}

					{/* Employee */}
					{ (userRole === 4) &&
						<nav className="sidebar-nav">
							<NavLink to="/dashboard" activeClassName="active">
								<Materialicon icon="dashboard" /> <span className="nav-name">Dashboard</span>
							</NavLink>

							<NavLink to="/hierarchy" activeClassName="active">
								<Materialicon icon="line_style" /> <span className="nav-name">Hierarchy</span>
							</NavLink>

							<NavLink to="/users" activeClassName="active">
								<Materialicon icon="people_outline" /> <span className="nav-name">Users</span>
							</NavLink>

							<NavLink to="/documents" activeClassName="active">
								<Materialicon icon="description" /> <span className="nav-name">Documents</span>
							</NavLink>
							
							<NavLink to="/tasks/log-hours" activeClassName="active">
								<Materialicon icon="note_add" /> <span className="nav-name">Log hours</span>
							</NavLink>

							<SubPages title="Tasks" icon="assignment" keyID={1}>
								<Link to="/tasks/my-tasks" itemID={1}> <span className="nav-name">My tasks</span> </Link>		
								<Link to="/my-logs" itemID={2}><span className="nav-name">My logs</span> </Link>
								<Link to="/logged-hours" itemID={3}><span className="nav-name">List of logs</span> </Link>																			
							</SubPages>	

							{ isTester && 
								<SubPages title="Bugs" icon="bug_report" keyID={2}>
									<Link to="/bugs" itemID={1}><span className="nav-name">All bugs</span></Link>
									<Link to="/bugs/create-bug" itemID={2}><span className="nav-name">New bug</span></Link>																
								</SubPages>
							}
			
							<SubPages title="Day Off" icon="timer_off" keyID={3}>
								<Link to="/days-off/calendar" itemID={2}><span className="nav-name">Calendar</span></Link>
								<Link to="/days-off/requests" itemID={3}><span className="nav-name">Requests</span></Link>																
							</SubPages>
						</nav>
					}
				</section>
				<a href="https://atis.al/" className="atis-link">
					<span><img src="" alt=""/></span>
					 <span className="nav-name">Powered by ATIS</span>
				</a>
			</aside>
		);
	}
}

Aside.propTypes = {
	globalState: PropTypes.shape({
		userLoginData: PropTypes.shape({
			user: PropTypes.shape({
				first_name: PropTypes.string,
				last_name: PropTypes.string,
				image: PropTypes.string,
				roles: PropTypes.array
			}).isRequired
		}).isRequired
	}).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Aside);



// WEBPACK FOOTER //
// ./src/components/navigation/Aside.js